import React, { useState, Fragment, useMemo } from "react";
import debounce from "lodash.debounce";
import { Link } from "react-router";
import {
  ContentIcon,
  DomainIcon,
  SubjectIcon,
  GradeIcon,
  PassageIcon,
  SkillIcon,
  QuestionIcon,
  LeftArrowIcon,
  SearchIcon,
  CircleLeftIcon,
  StandardIcon,
  MasterIcon,
  LiftoffIcon,
  LiftoffHeaderIcon,
  TagIcon,
  CannedTestIcon,
  CannedTestListIcon,
  CannedTestCreateIcon,
  LinkIcon,
  SellableProductIcon,
  BundelsIcon,
  PricingIcon,
  WorksheetIcon,
  SlideIcon,
  VideoIcon,
  TeacherQuestionIcon,
  PermissionsIcon,
  GroupIcon,
  UserIcon,
  StarIcon,
  CrmIcon,
  UtilitiesIcon,
  ClassifyCleanupIcon,
  MagicMatchIcon,
  LessonPlanIcon,
} from "../../../assets/icons/index";
import sidebarMenu from "../../../model/sidemenu";
import Constant from "../../../utils/constant";
import AllowedTo from "../common/rbac";

const Sidebar: React.FC = () => {
  const [toggleSideBar, setToggleSideBar] = useState<boolean>(true);
  const [showSubmenu, setShowSubmenu] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [filteredNavMenu, setFilteredNavMenu] = useState(sidebarMenu);
  const [active, setActive] = useState<string>("");
  const [linkClicked, setLinkClicked] = useState<boolean>(false);

  const menuToggleHandler = (menuItemName: string, event: any) => {
    if (event.target.localName !== "div") {
      setLinkClicked(false);
    }
    setShowSubmenu(menuItemName === showSubmenu ? "" : menuItemName);
  };

  const linkClickHandler = (menu: string) => {
    setLinkClicked(true);
    setActive(menu);
  };

  const determineShouldExpand = (menuName: string) => {
    if (active == menuName && toggleSideBar && linkClicked) {
      return true;
    }
    const itemExistInFilteredSidebarMenu = sidebarMenu.filter(
      (sideBarMenuItem) => {
        sideBarMenuItem.menu === menuName;
      }
    );
    if (itemExistInFilteredSidebarMenu && search) {
      return showSubmenu === menuName ? false : true;
    } else if (showSubmenu === menuName) {
      return true;
    }
    return false;
  };

  const deDuplicateArray = (finalFiltered) => {
    const filterSetObj = new Set();
    const deDuplicatedArray = finalFiltered.reduce((acc, item) => {
      if (!filterSetObj.has(item.id)) {
        filterSetObj.add(item.id);
        acc.push(item);
      }
      return acc;
    }, []);
    return deDuplicatedArray;
  };
  const searchHandler = (e) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const sideBarFilteredBymenu = sidebarMenu.filter((sideBarByMenu) =>
        sideBarByMenu.menu.toLowerCase().includes(e.target.value.toLowerCase())
      );

      const sideBarFilterBySubMenu = sidebarMenu.filter((sideBarBySubMenu) =>
        sideBarBySubMenu.submenu.some((subElement) =>
          subElement.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      if (
        sideBarFilteredBymenu.length > 0 &&
        sideBarFilterBySubMenu.length === 0
      ) {
        setFilteredNavMenu(sideBarFilteredBymenu);
        setToggleSideBar(true);
      }
      if (
        sideBarFilterBySubMenu.length > 0 &&
        sideBarFilteredBymenu.length === 0
      ) {
        setFilteredNavMenu(sideBarFilterBySubMenu);
        setToggleSideBar(true);
      }
      if (sideBarFilteredBymenu.length > 0 && sideBarFilterBySubMenu.length) {
        const filterationCombined = sideBarFilterBySubMenu.concat(
          sideBarFilteredBymenu
        );
        const resultArr = deDuplicateArray(filterationCombined);
        setFilteredNavMenu(resultArr);
        setToggleSideBar(true);
      }
    } else {
      setFilteredNavMenu(sidebarMenu);
    }
  };

  const debouncedChangeHandler = useMemo(
    () => debounce(searchHandler, 300),
    []
  );

  const submitHandler = (e) => {
    e.preventDefault();
    {
      const SearchedMenu = sidebarMenu.filter(
        (subject) => subject.menu === search
      );
      setFilteredNavMenu(SearchedMenu);
    }
  };

  /** Code to mark text by search term */
  const markSearchTerm = (text) => {
    const space = new RegExp(" ", "g");
    let alteredSpace = text.replace(space, `&nbsp;`);

    let searchTerm = search;
    if (searchTerm) searchTerm = searchTerm.replace(space, `&nbsp;`);
    searchTerm = searchTerm.toLocaleLowerCase();
    alteredSpace = alteredSpace.toLocaleLowerCase();

    if (searchTerm && alteredSpace.includes(searchTerm)) {
      return `<mark>${text}</mark>`;
    } else {
      return text;
    }
  };

  function getIcon(menu: string) {
    let icon: any = null;
    switch (menu) {
      case Constant.MASTER:
        icon = <MasterIcon className="w-5 h-5" />;
        break;
      case Constant.LIFTOFF:
        icon = <LiftoffIcon className="w-5 h-5" />;
        break;
      case Constant.LIFTOFFHEADER:
        icon = <LiftoffHeaderIcon className="w-5 h-5" />;
        break;
      case Constant.LIFTOFFSUBJECT:
        icon = <SubjectIcon className="w-5 h-5" />;
        break;
      case Constant.CONTENTS:
        icon = <ContentIcon className="w-5 h-5" />;
        break;
      case Constant.SUBJECTS:
        icon = <SubjectIcon className="w-5 h-5" />;
        break;
      case Constant.GRADES:
        icon = <GradeIcon className="w-5 h-5" />;
        break;
      case Constant.DOMAINS:
        icon = <DomainIcon className="w-5 h-5" />;
        break;
      case Constant.PASSAGE:
        icon = <PassageIcon className="w-5 h-5" />;
        break;
      case Constant.QUESTION:
        icon = <QuestionIcon className="w-4 h-4" />;
        break;
      case Constant.AUTHORQUESTION:
        icon = <QuestionIcon className="w-4 h-4" />;
        break;
      case Constant.TEACHER_QUESTION_LIST:
        icon = <TeacherQuestionIcon className="w-5 h-5" />;
        break;
      case Constant.STANDARDS:
        icon = <StandardIcon className="w-5 h-5" />;
        break;
      case Constant.TAGS:
        icon = <TagIcon className="w-5 h-5" />;
        break;
      case Constant.SKILLS:
        icon = <SkillIcon className="w-5 h-5" />;
        break;
      case Constant.SKILLPRACTICESUBJECT:
        icon = <SubjectIcon className="w-5 h-5" />;
        break;
      case Constant.SKILLPRACTICESTANDARD:
        icon = <StandardIcon className="w-5 h-5" />;
        break;
      case Constant.SKILLPRACTICEQUESTION:
        icon = <QuestionIcon className="w-4 h-4" />;
        break;
      case Constant.CANNEDTEST:
        icon = <CannedTestIcon className="w-5 h-5" />;
        break;
      case Constant.CANNEDTESTALL:
        icon = <CannedTestListIcon className="w-5 h-5" />;
        break;
      case Constant.CANNEDTESTCREATE:
        icon = <CannedTestCreateIcon className="w-5 h-5" />;
        break;
      case Constant.STANDARDLINK:
        icon = <LinkIcon className="w-5 h-5" />;
        break;
      case Constant.PRICING:
        icon = <PricingIcon className="w-5 h-5" />;
        break;
      case Constant.SELLABLEPRODUCT:
        icon = <SellableProductIcon className="w-5 h-5" />;
        break;
      case Constant.BUNDLES:
        icon = <BundelsIcon className="w-5 h-5" />;
        break;
      case Constant.WORKSHEETS:
        icon = <WorksheetIcon className="w-5 h-5" />;
        break;
      case Constant.VIDEOS:
        icon = <VideoIcon className="w-5 h-5" />;
        break;
      case Constant.SLIDES:
        icon = <SlideIcon className="w-5 h-5" />;
        break;
      case Constant.LESSONPLANS:
        icon = <LessonPlanIcon className="w-5 h-5" />;
        break;
      case Constant.STANDARDGROUPS:
        icon = <BundelsIcon className="w-5 h-5" />;
        break;
      case Constant.PERMISSIONS:
        icon = <PermissionsIcon className="w-5 h-5" />;
        break;
      case Constant.PERMISSION_GROUPS:
        icon = <GroupIcon className="w-5 h-5" />;
        break;
      case Constant.USER_PERMISSIONS:
        icon = <UserIcon className="w-5 h-5" />;
        break;
      case Constant.DEFAULT_SUBJECTS:
        icon = <StarIcon className="w-5 h-5" />;
        break;
      case Constant.CRM:
        icon = <CrmIcon className="w-5 h-5" />;
        break;
      case Constant.Utilities:
        icon = <UtilitiesIcon className="w-5 h-5" />;
        break;
      case Constant.ClassifyCleanup:
        icon = <ClassifyCleanupIcon className="w-5 h-5" />;
        break;
      case Constant.STANDARDS_MAGIC_MATCH:
        icon = <MagicMatchIcon className="w-5 h-5" />;
        break;
    }

    return icon;
  }

  function getActiveClass(menu: string, type: string) {
    const inActiveClassName = `${
      type == "close" ? "pl-2" : "pl-8"
    } group hover:text-white text-gray-700 dark:text-white flex items-center hover:bg-primary-color hover:bg-opacity-80`;
    const activeClassName = `${
      type == "close" ? "pl-2" : "pl-8"
    } group flex items-center text-white dark:text-white pl-8 bg-primary-color focus:bg-primary-color focus:text-white bg-primary-color`;

    if (window.location.pathname === menu) {
      return activeClassName;
    } else {
      return inActiveClassName;
    }
  }

  const hasPermission = (nav) => {
    if (
      AllowedTo({
        perform: nav.permission || "",
        asFunction: true,
      }) &&
      nav?.submenu?.length === 0
    ) {
      return true;
    } else if (nav?.submenu?.length > 0) {
      return true;
    } else if (
      AllowedTo({
        perform: nav.permission || "",
        asFunction: true,
      })
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div
        className={` ${
          toggleSideBar
            ? "flex-shrink-0 mb-5 bg-white w-64 transform transition-all duration-500 text-white flex justify-center shadow sticky top-0"
            : "bg-white w-64 transform transition-all duration-500 text-white flex justify-center -ml-48 shadow"
        } `}
      >
        <div className="md:flex md:flex-shrink-0 h-screen dark:bg-custom-black">
          <div className="flex flex-col w-64 h-screen	">
            <div className=" flex flex-col min-h-0  ">
              <div className=" flex flex-col pb-4 relative">
                <span
                  className={`${
                    toggleSideBar ? "" : "transform rotate-180"
                  } transition ease-linear duration-500 absolute -right-2.5 top-4 shadow-xl text-gray-500 cursor-pointer bg-white rounded-full hover:bg-primary-color hover:text-white dark:hover:bg-slate-400`}
                >
                  <CircleLeftIcon
                    onClick={() => {
                      setShowSubmenu("");
                      if (toggleSideBar) {
                        setSearch("");
                        setFilteredNavMenu(sidebarMenu);
                      }
                      setToggleSideBar(!toggleSideBar);
                    }}
                    className="w-5   "
                  ></CircleLeftIcon>
                </span>
                <nav className={"mt-10"}>
                  <form
                    autoComplete="off"
                    className="mt-1 flex rounded-md shadow-sm s"
                    action="#"
                    onSubmit={submitHandler}
                  >
                    {toggleSideBar && (
                      <Fragment>
                        <div className="relative flex w-full px-2 text-gray-500 focus-within:text-primary-color">
                          <input
                            type="text"
                            autoComplete="off"
                            name="search"
                            id="search"
                            onChange={debouncedChangeHandler}
                            className="searchInput focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black block w-full rounded-lg sm:text-sm border-gray-300 pl-8 py-1.5"
                            placeholder="Search..."
                          />
                          <SearchIcon className="absolute w-3.5 top-2.5 left-5 text-gray-500"></SearchIcon>
                        </div>
                      </Fragment>
                    )}
                  </form>
                  <div className="mt-4 font-Helvetica-Neue">
                    {filteredNavMenu.map((subject) => (
                      <div key={subject.id}>
                        <div
                          className={`mt-1 ${
                            !toggleSideBar &&
                            showSubmenu == subject.menu &&
                            "bg-gray-100 border-l-4 border-primary-color hover:bg-gray-100 border-t-2"
                          } ${
                            !toggleSideBar && "flex h-10 hover:bg-gray-100"
                          } ${determineShouldExpand(subject.menu)} 
                          `}
                          onClick={(e) => menuToggleHandler(subject.menu, e)}
                        >
                          {hasPermission(subject) && (
                            <button
                              type="button"
                              className={`text-primary-color dark:text-slate-600 group ${
                                toggleSideBar
                                  ? "w-full rounded-md"
                                  : "w-42 ml-auto "
                              }  mr-4 flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium transition ease-in-out duration-500`}
                              aria-controls="sub-menu-1"
                              aria-expanded="false"
                            >
                              {getIcon(subject.icon)}

                              {toggleSideBar && (
                                <Fragment>
                                  <span
                                    id="nav_div"
                                    className="capitalize flex-1 ml-2 font-Open-Sans"
                                    dangerouslySetInnerHTML={{
                                      __html: markSearchTerm(subject.menu),
                                    }}
                                  ></span>
                                  <LeftArrowIcon className="w-4"></LeftArrowIcon>
                                </Fragment>
                              )}
                            </button>
                          )}
                          {toggleSideBar && (
                            <div>
                              {subject.submenu.map(
                                (el) =>
                                  hasPermission(el) && (
                                    <div
                                      key={el.name}
                                      className={`h-10 ${
                                        determineShouldExpand(subject.menu)
                                          ? "space-y-1 font-Open-Sans"
                                          : "space-y-1 hidden"
                                      } ${getActiveClass(el.route, "open")}`}
                                      id="sub-menu-1"
                                    >
                                      <Link
                                        onClick={() =>
                                          linkClickHandler(subject.menu)
                                        }
                                        to={el.route}
                                        className={`${
                                          !search && "capitalize"
                                        } ${
                                          window.location.pathname == el.route
                                            ? "text-white"
                                            : "text-gray-700"
                                        } group-hover:text-white w-full flex items-center pr-2 py-2 text-sm`}
                                        key={el.name}
                                      >
                                        <div
                                          className={` group-hover:text-white
                                    ${
                                      window.location.pathname === el.route
                                        ? "text-white dark:text-black"
                                        : "text-gray-700 dark:text-white"
                                    }`}
                                        >
                                          {getIcon(el.icon)}
                                        </div>
                                        <div className="ml-2 inline-block">
                                          <div
                                            className={`${
                                              !search && "capitalize"
                                            } ${
                                              window.location.pathname ==
                                              el.route
                                                ? "text-white dark:text-white"
                                                : "text-gray-700 dark:text-white"
                                            } group-hover:text-white w-full flex items-center pr-2 py-2 text-sm`}
                                            dangerouslySetInnerHTML={{
                                              __html: markSearchTerm(el.name),
                                            }}
                                          ></div>
                                        </div>
                                      </Link>
                                    </div>
                                  )
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!toggleSideBar && (
        <div className="mt-4 font-Helvetica-Neue">
          {filteredNavMenu.map((subject, index) => (
            <div key={subject.id}>
              <div
                className={`mt-1 capitalize ${
                  determineShouldExpand(subject.menu) &&
                  !toggleSideBar &&
                  "bg-gray-100"
                } ${!toggleSideBar && " hover:bg-gray-100 hover:text-white"} `}
                onClick={(e) => menuToggleHandler(subject.menu, e)}
              >
                {!toggleSideBar && (
                  <div
                    className={`bg-gray-100 h-auto z-10 absolute w-56 sidebarBoxShadow ${
                      subject.menu == showSubmenu &&
                      "border-primary-color border-t-2"
                    }`}
                    style={{
                      top: `${124 + 44 * index}px`,
                    }}
                  >
                    {subject.submenu.map((el) => (
                      <div
                        key={el.name}
                        className={`${
                          determineShouldExpand(subject.menu)
                            ? "space-y-1 font-Open-Sans capitalize"
                            : "space-y-1 hidden capitalize"
                        } ${getActiveClass(el.route, "close")}`}
                        id="sub-menu-1"
                      >
                        <Link
                          to={el.route}
                          className={`group group-hover:text-white w-full flex capitalize items-center px-2 pr-2 py-2 text-sm ${
                            window.location.pathname === el.route
                              ? "text-white dark:text-white"
                              : "text-gray-700 dark:text-white"
                          }`}
                        >
                          <span
                            className={`ml-2 px-2 pr-2 py-2 group-hover:text-white ${
                              window.location.pathname === el.route
                                ? "text-white dark:text-white"
                                : "text-gray-700 dark:text-white"
                            }`}
                          >
                            {getIcon(el.icon)}
                          </span>
                          <span className="inline-block">{el.name}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Sidebar;
